// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let DateFns = require("date-fns");
let ViewStack = require("../../reason/common/ViewStack.bs.js");
let CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalNeedLeaseAttributes_rentalNeedV5_graphql = require("../../__generated__/RentalNeedLeaseAttributes_rentalNeedV5_graphql.bs.js");

let convertFragment = RentalNeedLeaseAttributes_rentalNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalNeedLeaseAttributes(props) {
  let match = RescriptRelay_Fragment.useFragment(RentalNeedLeaseAttributes_rentalNeedV5_graphql.node, convertFragment, props.rentalNeed);
  let availableFrom = match.availableFrom;
  let tmp;
  if (availableFrom !== undefined) {
    let from = DateFns.format(CalendarDate.toLocalDate(Primitive_option.valFromOption(availableFrom)), "M/d");
    tmp = " available on or before " + from;
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "lease requirements",
    children: JsxRuntime.jsxs(ViewStack.make, {
      space: "sm",
      flexDirection: "row",
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "calendar",
          className: "text-zinc-600"
        }),
        JsxRuntime.jsxs("span", {
          children: [
            match.leaseLength.displayName + ` term`,
            tmp
          ],
          className: "text-zinc-700"
        })
      ]
    })
  });
}

let make = RentalNeedLeaseAttributes;

exports.Fragment = Fragment;
exports.make = make;
/* IconV5 Not a pure module */
